import React, {ChangeEvent, FC, FormEvent, useEffect, useState} from "react";
import Breadcrumb, {Crumb} from "../../../../components/common/Breadcrumbs";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import {FaLink, FaSearch, FaTimes} from "react-icons/fa";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import IconButton from "../../../../components/common/form/IconButton";
import SelectField from "../../../../components/common/form/SelectField";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {useNavigate, useParams} from "react-router-dom";
import {
    useCreateJurisdictionMutation,
    useGetJurisdictionByIdQuery,
    useUpdateJurisdictionMutation
} from "../jurisdictionApi";
import {useGetAllStatesQuery} from "../../states/statesApi";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {Routes as AppRoutes} from "../../../../routes";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {useGetAllCountyByStateAbbrQuery} from "../../counties/countiesApi";
import {skipToken} from "@reduxjs/toolkit/query";
import {useSearchCollectorQuery} from "../../collector/collector";
import {
    addJurisdictionCode,
    addTaxRate,
    commonSortingList,
    createOptionListForSelectTag,
    deleteJurisdictionCodes,
    deleteTaxRate,
} from "../../../../helpers/utils/Utils";
import {ExemptionField, exemptionLabel} from "./Exemptions";
import {FaMagnifyingGlass} from "react-icons/fa6";

interface props {
    crumbs: Crumb[];
    title: string,
    btnText: string,
    isEditable?: boolean
}

const JurisdictionFormFields: FC<props> = ({crumbs, title, btnText, isEditable = false}) => {


    const navigate = useNavigate();
    let {jurisdictionId} = useParams();

    const [year, setYear] = useState<any>("");
    const [rate, setRate] = useState<any>("");
    const [taxRates, setTaxRates] = useState<any>([]);
    const [taxError, setTaxError] = useState<any>({});
    const [code, setCode] = useState<any>("");
    const [type, setType] = useState<any>({
        value: "APPRAISAL_DISTRICT",
        label: "Appraisal District"
    });
    const [jurisdictionCodes, setJurisdictionCodes] = useState<any>([]);
    const [codeError, setCodeError] = useState<any>({});

    const [createJurisdictionLink, createJurisdictionLinkApiResponse] = useCreateJurisdictionMutation();
    const [updateJurisdictionLink, updateJurisdictionLinkApiResponse] = useUpdateJurisdictionMutation();
    const JurisdictionById = useGetJurisdictionByIdQuery(jurisdictionId);
    const [jurisdictionData, setJurisdictionData] = useState<any>({});
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateAbbrQuery(jurisdictionData?.state?.value ?? skipToken);
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const {data: enums} = useGetEnumsQuery("");
    const [disabledVeteran71100Type, setDisabledVeteran71100Type] = useState('NONE');
    const [disabledVeteran71100FlatAmount, setDisabledVeteran71100FlatAmount] = useState<string | null>(null);
    const [disabledVeteran71100PerAmount, setDisabledVeteran71100PerAmount] = useState<string | null>(null);
    const [homesteadType, setHomesteadType] = useState('NONE');
    const [homesteadFlatAmount, setHomesteadFlatAmount] = useState<string | null>(null);
    const [homesteadPerAmount, setHomesteadPerAmount] = useState<string | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [showCollectorModal, setShowCollectorModal] = useState<boolean>(false);
    const [over65Type, setOver65Type] = useState('NONE');
    const [over65FlatAmount, setOver65FlatAmount] = useState<string | null>(null);
    const [over65PerAmount, setOver65PerAmount] = useState<string | null>(null);
    const [disabledPersonType, setDisabledPersonType] = useState('NONE');
    const [disabledPersonFlatAmount, setDisabledPersonFlatAmount] = useState<string | null>(null);
    const [disabledPersonPerAmount, setDisabledPersonPerAmount] = useState<string | null>(null);
    const [disabledVeteran1030Type, setDisabledVeteran1030Type] = useState('NONE');
    const [disabledVeteran1030FlatAmount, setDisabledVeteran1030FlatAmount] = useState<string | null>(null);
    const [disabledVeteran1030PerAmount, setDisabledVeteran1030PerAmount] = useState<string | null>(null);
    const [disabledVeteran3150Type, setDisabledVeteran3150Type] = useState('NONE');
    const [disabledVeteran3150FlatAmount, setDisabledVeteran3150FlatAmount] = useState<string | null>(null);
    const [disabledVeteran3150PerAmount, setDisabledVeteran3150PerAmount] = useState<string | null>(null);
    const [disabledVeteran5170Type, setDisabledVeteran5170Type] = useState('NONE');
    const [disabledVeteran5170FlatAmount, setDisabledVeteran5170FlatAmount] = useState<string | null>(null);
    const [disabledVeteran5170PerAmount, setDisabledVeteran5170PerAmount] = useState<string | null>(null);


    useEffect(() => {

        let obj = JurisdictionById?.data;
        if (obj) {
            setJurisdictionData({
                ...obj,
                collector: obj?.collector?.name,
            })
            setJurisdictionCodes(!obj.jurisdictionCodes ? [] : commonSortingList(obj.jurisdictionCodes, ['type'], ['asc']));

            setTaxRates(obj?.taxRates);
            setHomesteadType(obj?.exemptionDetails?.homesteadType || "NONE");
            setHomesteadFlatAmount(obj?.exemptionDetails?.homesteadValues?.flatAmount || null);
            setHomesteadPerAmount(obj?.exemptionDetails?.homesteadValues?.percentAmount?.toString() || null);

            setOver65Type(obj?.exemptionDetails?.over65Type || "NONE");
            setOver65FlatAmount(obj?.exemptionDetails?.over65Values?.flatAmount || null);
            setOver65PerAmount(obj?.exemptionDetails?.over65Values?.percentAmount?.toString() || null);

            setDisabledPersonType(obj?.exemptionDetails?.disabledPersonType || "NONE");
            setDisabledPersonFlatAmount(obj?.exemptionDetails?.disabledPersonValues?.flatAmount || null);
            setDisabledPersonPerAmount(obj?.exemptionDetails?.disabledPersonValues?.percentAmount?.toString() || null);

            setDisabledVeteran1030Type(obj?.exemptionDetails?.disabledVeteran1030Type || "NONE");
            setDisabledVeteran1030FlatAmount(obj?.exemptionDetails?.disabledVeteran1030Values?.flatAmount || null);
            setDisabledVeteran1030PerAmount(obj?.exemptionDetails?.disabledVeteran1030Values?.percentAmount?.toString() || null);

            setDisabledVeteran3150Type(obj?.exemptionDetails?.disabledVeteran3150Type || "NONE");
            setDisabledVeteran3150FlatAmount(obj?.exemptionDetails?.disabledVeteran3150Values?.flatAmount || null);
            setDisabledVeteran3150PerAmount(obj?.exemptionDetails?.disabledVeteran3150Values?.percentAmount?.toString() || null);

            setDisabledVeteran5170Type(obj?.exemptionDetails?.disabledVeteran5170Type || "NONE");
            setDisabledVeteran5170FlatAmount(obj?.exemptionDetails?.disabledVeteran5170Values?.flatAmount || null);
            setDisabledVeteran5170PerAmount(obj?.exemptionDetails?.disabledVeteran5170Values?.percentAmount?.toString() || null);

            setDisabledVeteran71100Type(obj?.exemptionDetails?.disabledVeteran71100Type || "NONE");
            setDisabledVeteran71100FlatAmount(obj?.exemptionDetails?.disabledVeteran71100Values?.flatAmount || null);
            setDisabledVeteran71100PerAmount(obj?.exemptionDetails?.disabledVeteran71100Values?.percentAmount?.toString() || null);
        }

    }, [JurisdictionById?.data]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const payload = {
            id: jurisdictionData.id || null,
            name: jurisdictionData.name,
            jurisdictionType: jurisdictionData?.type?.value,
            earlyPaymentDiscount: jurisdictionData?.earlyPaymentDiscount || false,
            attorneyFeePercentage: parseFloat(jurisdictionData.attorneyFeePercentage || "0"),
            earlyAttorneyFeePercentage: parseFloat(jurisdictionData.earlyAttorneyFeePercentage || "0"),
            nonCollecting: jurisdictionData.nonCollecting || false,
            inActive: jurisdictionData.inActive || false,
            inactiveYear: jurisdictionData.inactiveYear || null,
            countyId: jurisdictionData?.county.value,
            collector: {
                id: selectedRow.id,
            },

            taxRates: taxRates,
            exemptionDetails: {
                id: null,

                homesteadType,
                homesteadValues:
                    homesteadFlatAmount || homesteadPerAmount
                        ? {
                            flatAmount: homesteadFlatAmount || null,
                            percentAmount: homesteadPerAmount ? parseFloat(homesteadPerAmount) : null,
                        }
                        : null,

                over65Type,
                over65Values:
                    over65FlatAmount || over65PerAmount
                        ? {
                            flatAmount: over65FlatAmount || null,
                            percentAmount: over65PerAmount ? parseFloat(over65PerAmount) : null,
                        }
                        : null,

                disabledPersonType,
                disabledPersonValues:
                    disabledPersonFlatAmount || disabledPersonPerAmount
                        ? {
                            flatAmount: disabledPersonFlatAmount || null,
                            percentAmount: disabledPersonPerAmount ? parseFloat(disabledPersonPerAmount) : null,
                        }
                        : null,

                disabledVeteran1030Type,
                disabledVeteran1030Values:
                    disabledVeteran1030FlatAmount || disabledVeteran1030PerAmount
                        ? {
                            flatAmount: disabledVeteran1030FlatAmount || null,
                            percentAmount: disabledVeteran1030PerAmount ? parseFloat(disabledVeteran1030PerAmount) : null,
                        }
                        : null,

                disabledVeteran3150Type,
                disabledVeteran3150Values:
                    disabledVeteran3150FlatAmount || disabledVeteran3150PerAmount
                        ? {
                            flatAmount: disabledVeteran3150FlatAmount || null,
                            percentAmount: disabledVeteran3150PerAmount ? parseFloat(disabledVeteran3150PerAmount) : null,
                        }
                        : null,

                disabledVeteran5170Type,
                disabledVeteran5170Values:
                    disabledVeteran5170FlatAmount || disabledVeteran5170PerAmount
                        ? {
                            flatAmount: disabledVeteran5170FlatAmount || null,
                            percentAmount: disabledVeteran5170PerAmount ? parseFloat(disabledVeteran5170PerAmount) : null,
                        }
                        : null,

                disabledVeteran71100Type,
                disabledVeteran71100Values:
                    disabledVeteran71100FlatAmount || disabledVeteran71100PerAmount
                        ? {
                            flatAmount: disabledVeteran71100FlatAmount || null,
                            percentAmount: disabledVeteran71100PerAmount ? parseFloat(disabledVeteran71100PerAmount) : null,
                        }
                        : null,
            },

            jurisdictionCodes: jurisdictionCodes?.map((item: any) => ({
                type: item.type,
                code: item.code,
            })),

        };

        const createOrUpdateJurisdictionLink = async () => {
            if (btnText === "Create") {
                return await createJurisdictionLink(payload).unwrap();
            } else {
                return await updateJurisdictionLink({
                    id: jurisdictionId,
                    requestBody: payload,
                }).unwrap();
            }
        };

        await handleRTKQuery(createOrUpdateJurisdictionLink, (response: any) => {
             if (response?.success || response?.data?.success) {
                setJurisdictionData({});
                navigate(AppRoutes.Jurisdiction.path);
            }
        });
    }

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | {
        name: string;
        value: any
    } | ChangeEvent<HTMLTextAreaElement>) => {
        const {name, value} = "target" in e ? e.target : e;
        if (name == "state") {
            setJurisdictionData({
                ...jurisdictionData,
                county: null,
                collector: null,
                [name]: value,
            })

        } else {
            setJurisdictionData((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    }
    const handleClearCollector = () => {
        setJurisdictionData(() => ({
            ...jurisdictionData,
            collector: '',
        }));
    };

    const handleOnClick = (e: any) => {
        e.preventDefault();
        setJurisdictionData({
            ...jurisdictionData,
            collector: selectedRow.name
        })
        setShowCollectorModal(false);
    }

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''}/>
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },
        {label: "State", accessor: "state.stateAbbreviation"},
        {label: "County", accessor: "countyName"}

    ];

    const handleToggle = (property: string) => () => {
        setJurisdictionData((prevData: any) => ({
            ...prevData,
            [property]: !prevData[property]
        }));
    };

    return <>
        <div className="px-4 py-2">

            <div className={"justify-between sm:block md:flex lg:flex"}>
                <Breadcrumb crumbs={crumbs}/>
            </div>

            <div className="flex justify-center mt-3 text-sm">
                <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                    <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-5">{title}</h3>
                    <Form onSubmit={handleSubmit} fields={<>
                        <div className="grid grid-cols-12">
                            <InputField
                                name={"name"}
                                label="Jurisdiction Name"
                                onChange={handleOnChange}
                                value={jurisdictionData?.name || ""}
                                type="text"
                                placeholder="Enter Name..."
                                required={true}
                            />
                            <SelectField
                                placeholder='Select Jurisdiction Type...'
                                value={jurisdictionData?.type}
                                options={createOptionListForSelectTag(enums?.["JurisdictionType"], "value", "constant")}
                                onChange={(selectedOption) => {
                                    handleOnChange({name: "type", value: selectedOption})
                                }}
                                label={"Jurisdiction Type"}
                                required={true}
                            />

                            <SelectField
                                placeholder='Select State...'
                                value={jurisdictionData?.state}
                                options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "stateAbbreviation")}
                                onChange={(selectedOption) => {
                                    handleOnChange({name: "state", value: selectedOption})
                                }}
                                label={"State"}
                                required={true}
                            />
                            <SelectField
                                placeholder='Select County...'
                                value={jurisdictionData?.county}
                                options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({name: "county", value: selectedOption})
                                }}
                                label={"County"}
                                required={true}
                                isDisabled={!jurisdictionData?.state}

                            />
                            <InputField
                                name="collector"
                                label="Collector"
                                onChange={handleOnChange}
                                value={jurisdictionData?.collector || ""}
                                type="text"
                                placeholder="Enter Collector..."
                                required
                                disabled={!jurisdictionData?.state}
                                icon={<IconButton
                                    icon={<FaLink onClick={() => {
                                        if (selectedRow?.id) {
                                            window.open(`/collectors/${selectedRow.id}`, '_blank');
                                        }
                                    }}/>
                                    }
                                    className={`text-sm ${jurisdictionData?.collector ? 'text-highlight-4' : 'text-surface-4'
                                    }`}
                                    title={"CreateJurisdiction"}
                                />}
                                onClick={() => {
                                    setShowCollectorModal(true);
                                }}
                                className="cursor-pointer"
                                inputIcon={
                                    jurisdictionData?.collector ? (
                                        <FaTimes
                                            className={iconButtonStyle}
                                            title="Clear Data"
                                            onClick={handleClearCollector}
                                        />
                                    ) : (
                                        <FaSearch className="fa cursor-pointer text-highlight-0 absolute right-5 top-6"
                                                  title="show Modal"
                                                  onClick={() => {
                                                      setShowCollectorModal(true);
                                                  }}
                                        />
                                    )

                                }
                            />

                            <InputField
                                name={"attorneyFeePercentage"}
                                label="Attorney Fee Per(%)"
                                onChange={handleOnChange}
                                value={jurisdictionData?.attorneyFeePercentage || ""}
                                type="number"
                                placeholder="Enter Attorney Fee Percentage..."
                                required={true}
                            />


                            <InputField
                                name={"earlyAttorneyFeePercentage"}
                                label="Early Attorney Fee Per(%)"
                                onChange={handleOnChange}
                                value={jurisdictionData?.earlyAttorneyFeePercentage || ""}
                                type="number"
                                placeholder="Enter Attorney Fee Percentage..."
                                required={true}
                            />

                            <div className="col-span-12 grid grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                    <label className="min-w-[100px]">*Tax Rate</label>
                                </div>

                                <div className="relative col-span-9 flex items-center gap-3">
                                    <div className="w-full">
                                        <InputField
                                            className={taxError?.year ? "form-control error_style" : "form-control"}
                                            type="number"
                                            minLength={4} maxLength={4} name="year"
                                            value={year}
                                            onChange={(e) => {
                                                // setEditable(true);
                                                setYear(e.target.value)
                                            }}
                                            hideLabel
                                            placeholder="Enter Year..."
                                        />
                                        <p className="mt-1">{taxError.year}</p>
                                    </div>

                                    <div className="w-full">
                                        <InputField
                                            className={taxError.rate ? "form-control error_style" : "form-control"}
                                            type="number" name="rate"
                                            value={rate}
                                            onChange={(e) => {
                                                // setEditable(true);
                                                setRate(e.target.value)
                                            }
                                            }
                                            hideLabel
                                            placeholder="Enter Rate..."
                                        />
                                        <p className="mt-1">{taxError.rate}</p>
                                    </div>
                                    {!isEditable &&
                                        <div className="col-sm-2 mt-2">
                                            <i className="fa fa-plus-circle m-md-0 cursor text-highlight-0"
                                               title="Add Tax-Rate..."
                                               data-backdrop="static"
                                               onClick={() => {
                                                   // setEditable(true);
                                                   addTaxRate(setTaxError,
                                                       taxRates,
                                                       setTaxRates,
                                                       year,
                                                       setYear,
                                                       rate,
                                                       setRate
                                                   )
                                               }}/>
                                        </div>}
                                </div>

                            </div>
                            <div className="col-span-12 grid grid-cols-12 gap-3">
                                {taxRates?.map((curEl: any, index: any) => {
                                    return <>

                                        <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        </div>
                                        <div className="relative col-span-9 flex items-center gap-3">

                                            <div className="w-full">
                                                <InputField className="form-control"
                                                            type="number"
                                                            name="year"
                                                            value={curEl.year}
                                                            placeholder="Enter Year..."
                                                            disabled={true} hideLabel/>
                                            </div>

                                            <div className="w-full">
                                                <InputField className="form-control"
                                                            type="number"
                                                            name="rate"
                                                            value={curEl.rate}
                                                            disabled={true} hideLabel
                                                />
                                            </div>

                                            {!isEditable &&
                                                <div className="col-sm-2 mt-1">
                                                    <i className="fa fa-trash m-md-0 cursor text-highlight-0"
                                                       title="Delete Tax-Rate..."
                                                       data-backdrop="static"
                                                       onClick={() => {
                                                           // setEditable(true);
                                                           deleteTaxRate(index, {setTaxRates})
                                                       }}
                                                    />
                                                </div>
                                            }
                                        </div>


                                    </>
                                })}
                            </div>

                            <div className="col-span-12 grid grid-cols-12 gap-3 mt-2">
                                <div className="col-span-3 sm:mt-2 lg:mt-0  flex items-center">
                                    <label className="min-w-[100px]">Jurisdiction Codes</label>
                                </div>

                                <div className="relative col-span-9 flex items-center gap-3">
                                    <div className="w-full">
                                        <SelectField
                                            placeholder='Select Jurisdiction Type...'
                                            value={type}
                                            options={createOptionListForSelectTag(enums?.["JurisdictionCodeType"], "value", "constant")}
                                            onChange={(selectedOption) => {
                                                setType(selectedOption);
                                            }}
                                            label={"Jurisdiction Type"}
                                            hideLabel={true}
                                            className="col-span-12"
                                        />
                                    </div>
                                    <div className="w-full mt-0">
                                        <InputField
                                            className={codeError.code ? "form-control error_style" : "form-control"}
                                            type="text" name="code"
                                            value={code}
                                            onChange={(e) => {
                                                // setEditable(true);
                                                setCode(e.target.value)
                                            }}
                                            hideLabel
                                            placeholder="Enter Code..."
                                            disabled={isEditable}/>
                                        <p className="mb-0">{codeError.code}</p>
                                    </div>
                                    {!isEditable &&
                                        <div className="col-sm-2 mt-2">
                                            <i className="fa fa-plus-circle m-md-0 cursor text-highlight-0"
                                               title="Add Jurisdiction Code..."
                                               data-backdrop="static"
                                               onClick={() => addJurisdictionCode(1, {
                                                   jurisdictionCodes,
                                                   setJurisdictionCodes,
                                                   setCodeError,
                                                   type,
                                                   setType,
                                                   code,
                                                   setCode
                                               })}
                                            />
                                        </div>}
                                </div>

                            </div>

                            <div className="col-span-12 grid grid-cols-12 gap-3">
                                {jurisdictionCodes?.map((curEl: any, index: any) => {
                                    return <>
                                        <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        </div>
                                        <div className="relative col-span-9 flex items-center gap-3">
                                            <div className="w-full">
                                                <InputField className="form-control"
                                                            type="text"
                                                            name="type"
                                                            value={curEl?.type}
                                                            disabled={true} hideLabel
                                                />

                                            </div>
                                            <div className="w-full">
                                                <InputField className="form-control"
                                                            type="text"
                                                            name="code"
                                                            value={curEl.code}
                                                            disabled={true} hideLabel
                                                />
                                            </div>

                                            {!isEditable &&
                                                <div className="col-sm-2 mt-1">
                                                    <i className="fa fa-trash m-md-0 cursor text-highlight-0"
                                                       title="Delete Jurisdiction Code..."
                                                       data-backdrop="static"
                                                       onClick={() => {
                                                           // setEditable(true);
                                                           deleteJurisdictionCodes(index, {setJurisdictionCodes})
                                                       }}
                                                    />
                                                </div>}

                                        </div>


                                    </>
                                })}
                            </div>
                            {exemptionLabel()}
                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Homestead"
                                type={homesteadType ?? ""}
                                setType={setHomesteadType}
                                flatAmount={homesteadFlatAmount ?? ""}
                                setFlatAmount={setHomesteadFlatAmount}
                                perAmount={homesteadPerAmount ?? ""}
                                setPerAmount={setHomesteadPerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Over 65"
                                type={over65Type ?? ""}
                                setType={setOver65Type}
                                flatAmount={over65FlatAmount ?? ""}
                                setFlatAmount={setOver65FlatAmount}
                                perAmount={over65PerAmount ?? ""}
                                setPerAmount={setOver65PerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Disabled Person"
                                type={disabledPersonType ?? ""}
                                setType={setDisabledPersonType}
                                flatAmount={disabledPersonFlatAmount ?? ""}
                                setFlatAmount={setDisabledPersonFlatAmount}
                                perAmount={disabledPersonPerAmount ?? ""}
                                setPerAmount={setDisabledPersonPerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Disabled Veteran 10-30%"
                                type={disabledVeteran1030Type ?? ""}
                                setType={setDisabledVeteran1030Type}
                                flatAmount={disabledVeteran1030FlatAmount ?? ""}
                                setFlatAmount={setDisabledVeteran1030FlatAmount}
                                perAmount={disabledVeteran1030PerAmount ?? ""}
                                setPerAmount={setDisabledVeteran1030PerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Disabled Veteran 31-50%"
                                type={disabledVeteran3150Type ?? ""}
                                setType={setDisabledVeteran3150Type}
                                flatAmount={disabledVeteran3150FlatAmount ?? ""}
                                setFlatAmount={setDisabledVeteran3150FlatAmount}
                                perAmount={disabledVeteran3150PerAmount ?? ""}
                                setPerAmount={setDisabledVeteran3150PerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Disabled Veteran 51-70%"
                                type={disabledVeteran5170Type ?? ""}
                                setType={setDisabledVeteran5170Type}
                                flatAmount={disabledVeteran5170FlatAmount ?? ""}
                                setFlatAmount={setDisabledVeteran5170FlatAmount}
                                perAmount={disabledVeteran5170PerAmount ?? ""}
                                setPerAmount={setDisabledVeteran5170PerAmount}
                                formType={btnText}
                            />

                            <ExemptionField
                                enums={enums?.["ExemptionType"] ?? []}
                                name="Disabled Veteran 71-100%"
                                type={disabledVeteran71100Type ?? ""}
                                setType={setDisabledVeteran71100Type}
                                flatAmount={disabledVeteran71100FlatAmount ?? ""}
                                setFlatAmount={setDisabledVeteran71100FlatAmount}
                                perAmount={disabledVeteran71100PerAmount ?? ""}
                                setPerAmount={setDisabledVeteran71100PerAmount}
                                formType={btnText}
                            />
                            <InputField
                                name={"nonCollecting"}
                                label="Non Collecting"
                                onChange={handleToggle("nonCollecting")}
                                checked={jurisdictionData?.nonCollecting || ""}
                                type="checkbox"
                            />

                            <InputField
                                name="inactive"
                                label="Inactive"
                                checked={jurisdictionData?.inactive || ""}
                                type="checkbox"
                                onChange={handleToggle("inactive")}
                            />

                        </div>

                        <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                            <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                            </div>
                            <div className="relative col-span-9">
                                <div className={"mt-4 flex"}>
                                    <ButtonTray
                                        buttons={[
                                            {
                                                buttonProps: {
                                                    btnText: "Cancel",
                                                    onClick: () => navigate(AppRoutes.Jurisdiction.path),
                                                    type: "close",
                                                },
                                                buttonType: "button"
                                            },
                                            {
                                                buttonProps: {
                                                    btnText: "Submit",
                                                    type: "submit",
                                                    isLoading: (createJurisdictionLinkApiResponse.isLoading || updateJurisdictionLinkApiResponse.isLoading),

                                                },
                                                buttonType: "button",

                                            }
                                        ]}
                                        align="center"
                                        gap={2}
                                    />
                                </div>
                            </div>
                        </div>

                    </>}
                    />

                </div>
            </div>
            {showCollectorModal &&
                <CommonSelectorModal
                    title="Select Collector"
                    columns={columns}
                    data={useSearchCollectorQuery}
                    show={showCollectorModal}
                    onSubmit={handleOnClick}
                    customerFilter={{
                        sort: "name",
                        sortOrder: "ASCENDING",
                        state: jurisdictionData?.state?.value
                    }}
                    setShow={setShowCollectorModal}
                    setSelectedRow={setSelectedRow}
                />
            }
        </div>
    </>

}

export default JurisdictionFormFields;